/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AbstractBatchReimbursementExportRequest,
  AcceptBusinessPurchaseExpenseCustomisationDto,
  AcceptMileageExpenseCustomisationDto,
  AcceptPerDiemExpenseCustomisationDto,
  AccountsPayableAuditLogActivity,
  AllowCommuteRatesCustomisationDto,
  AllowDistanceOverrideCustomisationDto,
  AllowDistanceRoundDownCustomisationDto,
  ApprovalStepActivity,
  ApprovalStepActivityV2,
  BatchReimbursementExportRequest,
  CalculateMileageQuery,
  CommentActivity,
  DownloadFilePayload,
  EmployeeEditAttributesReimbursementCustomisationDto,
  ExportEventActivity,
  ExternalActionActivityV2,
  FileAttachmentDto,
  FindByIdParams4,
  GetExportStatusUpdateCompletionStatusForReimbursementsPayload,
  GetReimbursementsByIdsRequest,
  GetReimbursementsRequest,
  HandleCustomisationRequestPayload,
  HandleRequestBody,
  HandleRequestParams1,
  HandleRequestV2Params,
  HandleRequestV2Payload,
  MileageCalculationResultDto,
  MileageReceiptUploadCustomisationDto,
  MoveBackStatusChangePayload,
  PaginatedGetReimbursementsRequest,
  PaginatedResponseReimbursementWithPaymentDetailsDtoObject,
  PayFromMossReimbursementCustomisationDto,
  PaymentActivity,
  PerDiemCalculationRequest,
  PerDiemCalculationResult,
  ReimbursementSepaPaymentFileExportRequest,
  ReimbursementSepaPaymentPreviewSummaryDto,
  ReimbursementSummaryDataDto,
  ReimbursementWithPaymentDetailsDto,
  ReviewBeforeApprovalCustomisationDto,
  StatusChangeActivity,
  SystemActionActivityV2,
  SystemPaymentActionActivityV2,
  UploadExpenseFilePayload,
  UploadMileageFilePayload,
  UseCustomMileageRatesCustomisationDto,
  UserActionActivity,
  UserActionActivityV2,
  UserFieldChangeActivity,
  VerificationStepActivityV2,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiReimbursementController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name MoveBackStatusChange
   * @request PUT:/api/v1/reimbursement/move-back-status-change
   */
  moveBackStatusChange = (data: MoveBackStatusChangePayload, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/reimbursement/move-back-status-change`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static moveBackStatusChangePath = '/v1/reimbursement/move-back-status-change'
  static moveBackStatusChangeMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name UploadMileageFile
   * @request POST:/api/v1/reimbursement/{reimbursementId}/mileage/attachment
   */
  uploadMileageFile = (
    reimbursementId: string,
    data: UploadMileageFilePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FileAttachmentDto, any>({
      path: `/v1/reimbursement/${reimbursementId}/mileage/attachment`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadMileageFilePath = '/v1/reimbursement/${reimbursementId}/mileage/attachment'
  static uploadMileageFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name FetchReimbursementSummaryData
   * @request POST:/api/v1/reimbursement/summary-data
   */
  fetchReimbursementSummaryData = (data: GetReimbursementsRequest, params: RequestParams = {}) =>
    this.http.request<ReimbursementSummaryDataDto, any>({
      path: `/v1/reimbursement/summary-data`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static fetchReimbursementSummaryDataPath = '/v1/reimbursement/summary-data'
  static fetchReimbursementSummaryDataMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name PreviewSepaPaymentFile
   * @request POST:/api/v1/reimbursement/sepa-file/preview
   */
  previewSepaPaymentFile = (
    data: ReimbursementSepaPaymentFileExportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ReimbursementSepaPaymentPreviewSummaryDto, any>({
      path: `/v1/reimbursement/sepa-file/preview`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static previewSepaPaymentFilePath = '/v1/reimbursement/sepa-file/preview'
  static previewSepaPaymentFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name ExportSepaPaymentFile
   * @request POST:/api/v1/reimbursement/sepa-file/export
   */
  exportSepaPaymentFile = (
    data: ReimbursementSepaPaymentFileExportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/reimbursement/sepa-file/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exportSepaPaymentFilePath = '/v1/reimbursement/sepa-file/export'
  static exportSepaPaymentFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name HandleRequest
   * @request POST:/api/v1/reimbursement/request
   */
  handleRequest = (
    query: HandleRequestParams1,
    data: HandleRequestBody,
    params: RequestParams = {},
  ) =>
    this.http.request<ReimbursementWithPaymentDetailsDto, any>({
      path: `/v1/reimbursement/request`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleRequestPath = '/v1/reimbursement/request'
  static handleRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name HandleRequestV2
   * @request POST:/api/v1/reimbursement/request/v2
   */
  handleRequestV2 = (
    query: HandleRequestV2Params,
    data: HandleRequestV2Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<ReimbursementWithPaymentDetailsDto[], any>({
      path: `/v1/reimbursement/request/v2`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleRequestV2Path = '/v1/reimbursement/request/v2'
  static handleRequestV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name CalculatePerDiem
   * @request POST:/api/v1/reimbursement/perdiem
   */
  calculatePerDiem = (data: PerDiemCalculationRequest, params: RequestParams = {}) =>
    this.http.request<PerDiemCalculationResult, any>({
      path: `/v1/reimbursement/perdiem`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculatePerDiemPath = '/v1/reimbursement/perdiem'
  static calculatePerDiemMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name FetchPaginatedReimbursements
   * @request POST:/api/v1/reimbursement/paged
   */
  fetchPaginatedReimbursements = (
    data: PaginatedGetReimbursementsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PaginatedResponseReimbursementWithPaymentDetailsDtoObject, any>({
      path: `/v1/reimbursement/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static fetchPaginatedReimbursementsPath = '/v1/reimbursement/paged'
  static fetchPaginatedReimbursementsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name CalculateMileageV2
   * @request POST:/api/v1/reimbursement/mileage
   */
  calculateMileageV2 = (data: CalculateMileageQuery, params: RequestParams = {}) =>
    this.http.request<MileageCalculationResultDto, any>({
      path: `/v1/reimbursement/mileage`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculateMileageV2Path = '/v1/reimbursement/mileage'
  static calculateMileageV2Method = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name CalculateMileageV3
   * @request POST:/api/v1/reimbursement/mileage/v3
   */
  calculateMileageV3 = (data: CalculateMileageQuery, params: RequestParams = {}) =>
    this.http.request<MileageCalculationResultDto, any>({
      path: `/v1/reimbursement/mileage/v3`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculateMileageV3Path = '/v1/reimbursement/mileage/v3'
  static calculateMileageV3Method = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name Export
   * @request POST:/api/v1/reimbursement/export
   */
  export = (data: AbstractBatchReimbursementExportRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/reimbursement/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exportPath = '/v1/reimbursement/export'
  static exportMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name GetExportStatusUpdateCompletionStatusForReimbursements
   * @request POST:/api/v1/reimbursement/export-status-update-completion/status/ids
   */
  getExportStatusUpdateCompletionStatusForReimbursements = (
    data: GetExportStatusUpdateCompletionStatusForReimbursementsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<'COMPLETED' | 'NOT_COMPLETED', any>({
      path: `/v1/reimbursement/export-status-update-completion/status/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getExportStatusUpdateCompletionStatusForReimbursementsPath =
    '/v1/reimbursement/export-status-update-completion/status/ids'
  static getExportStatusUpdateCompletionStatusForReimbursementsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name UploadExpenseFile
   * @request POST:/api/v1/reimbursement/expense/{expenseId}/attachment
   */
  uploadExpenseFile = (
    expenseId: string,
    data: UploadExpenseFilePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FileAttachmentDto, any>({
      path: `/v1/reimbursement/expense/${expenseId}/attachment`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadExpenseFilePath = '/v1/reimbursement/expense/${expenseId}/attachment'
  static uploadExpenseFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name DownloadFile
   * @request POST:/api/v1/reimbursement/download
   */
  downloadFile = (data: DownloadFilePayload, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/reimbursement/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static downloadFilePath = '/v1/reimbursement/download'
  static downloadFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name HandleCustomisationRequest
   * @request POST:/api/v1/reimbursement/customisation/request
   */
  handleCustomisationRequest = (
    data: HandleCustomisationRequestPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<
      | AcceptBusinessPurchaseExpenseCustomisationDto
      | AcceptMileageExpenseCustomisationDto
      | AcceptPerDiemExpenseCustomisationDto
      | AllowCommuteRatesCustomisationDto
      | AllowDistanceOverrideCustomisationDto
      | AllowDistanceRoundDownCustomisationDto
      | EmployeeEditAttributesReimbursementCustomisationDto
      | MileageReceiptUploadCustomisationDto
      | PayFromMossReimbursementCustomisationDto
      | ReviewBeforeApprovalCustomisationDto
      | UseCustomMileageRatesCustomisationDto,
      any
    >({
      path: `/v1/reimbursement/customisation/request`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static handleCustomisationRequestPath = '/v1/reimbursement/customisation/request'
  static handleCustomisationRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name DownloadCsv
   * @request POST:/api/v1/reimbursement/csv
   */
  downloadCsv = (data: BatchReimbursementExportRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/reimbursement/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static downloadCsvPath = '/v1/reimbursement/csv'
  static downloadCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name DownloadCustomCsv
   * @request POST:/api/v1/reimbursement/csv/templates/{templateId}
   */
  downloadCustomCsv = (
    templateId: string,
    data: GetReimbursementsByIdsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/reimbursement/csv/templates/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadCustomCsvPath = '/v1/reimbursement/csv/templates/${templateId}'
  static downloadCustomCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name FetchReimbursementsIdsWithoutPagination
   * @request POST:/api/v1/reimbursement/all/ids
   */
  fetchReimbursementsIdsWithoutPagination = (
    data: PaginatedGetReimbursementsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/reimbursement/all/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static fetchReimbursementsIdsWithoutPaginationPath = '/v1/reimbursement/all/ids'
  static fetchReimbursementsIdsWithoutPaginationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name FindActivityByReimbursementId
   * @request GET:/api/v1/reimbursement/{reimbursementId}/activity/V2
   */
  findActivityByReimbursementId = (reimbursementId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | AccountsPayableAuditLogActivity
        | ApprovalStepActivity
        | ApprovalStepActivityV2
        | CommentActivity
        | ExportEventActivity
        | ExternalActionActivityV2
        | PaymentActivity
        | StatusChangeActivity
        | SystemActionActivityV2
        | SystemPaymentActionActivityV2
        | UserActionActivity
        | UserActionActivityV2
        | UserFieldChangeActivity
        | VerificationStepActivityV2
      )[],
      any
    >({
      path: `/v1/reimbursement/${reimbursementId}/activity/V2`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findActivityByReimbursementIdPath = '/v1/reimbursement/${reimbursementId}/activity/V2'
  static findActivityByReimbursementIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name FindById
   * @request GET:/api/v1/reimbursement/{id}
   */
  findById = ({ id, ...query }: FindByIdParams4, params: RequestParams = {}) =>
    this.http.request<ReimbursementWithPaymentDetailsDto, any>({
      path: `/v1/reimbursement/${id}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findByIdPath = '/v1/reimbursement/${id}'
  static findByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name GetCustomisationSettings
   * @request GET:/api/v1/reimbursement/customisation/settings
   */
  getCustomisationSettings = (params: RequestParams = {}) =>
    this.http.request<
      (
        | AcceptBusinessPurchaseExpenseCustomisationDto
        | AcceptMileageExpenseCustomisationDto
        | AcceptPerDiemExpenseCustomisationDto
        | AllowCommuteRatesCustomisationDto
        | AllowDistanceOverrideCustomisationDto
        | AllowDistanceRoundDownCustomisationDto
        | EmployeeEditAttributesReimbursementCustomisationDto
        | MileageReceiptUploadCustomisationDto
        | PayFromMossReimbursementCustomisationDto
        | ReviewBeforeApprovalCustomisationDto
        | UseCustomMileageRatesCustomisationDto
      )[],
      any
    >({
      path: `/v1/reimbursement/customisation/settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCustomisationSettingsPath = '/v1/reimbursement/customisation/settings'
  static getCustomisationSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name DeleteMileageFile
   * @request DELETE:/api/v1/reimbursement/{reimbursementId}/mileage/attachment/{fileId}
   */
  deleteMileageFile = (reimbursementId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/reimbursement/${reimbursementId}/mileage/attachment/${fileId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteMileageFilePath = '/v1/reimbursement/${reimbursementId}/mileage/attachment/${fileId}'
  static deleteMileageFileMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-reimbursement-controller
   * @name DeleteExpenseFile
   * @request DELETE:/api/v1/reimbursement/expense/{expenseId}/attachment/{fileId}
   */
  deleteExpenseFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/reimbursement/expense/${expenseId}/attachment/${fileId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteExpenseFilePath = '/v1/reimbursement/expense/${expenseId}/attachment/${fileId}'
  static deleteExpenseFileMethod = 'DELETE'
}
